import CatalogCard from "@/Components/Site/CatalogCard";
import useViewItemBatcher from "@/Hooks/useViewItemBatcher";

const CatalogCardBlock = ({items = []}) => {
    const {registerView} = useViewItemBatcher();

    if (!items.length) return null;

    return (
        <div className={`re-products`}>
            {items.map((product, index) => (
                <CatalogCard
                    key={index}
                    el={product}
                    index={index + 1}
                    registerView={registerView}
                />
            ))}
        </div>
    );
};

export default CatalogCardBlock;
